import React from 'react'
import { MuiGrid } from '../../../ui/MaterialUIComponents';

import ScheduleTitleBarComponent from './ScheduleTitleBarComponent'
import '../../../ui/scrollbarForLog.css'
import ScheduleListComponent from './ScheduleListComponent'
import theme from '../../../../assests/theme'
import spinner from "../../../ui/icons/spinner.gif";
import lodashUtil from 'lodash';
import { saveSchoolConcurrently, saveSchoolScheduleConstraintsConcurrently } from '../../../../utils/ConcurrentSchoolSaveUtil';
import { Redirect } from 'react-router-dom';
import routes from "../../../navigation/Routes"

export default function ScheduleComponent(props) {
  const sortedScheduleConstraints = props.activeSchool.schedule_constraints.sort((b, a) => new Date(a.modifiedDate).getTime() - new Date(b.modifiedDate).getTime())

  const [scheduleList, setScheduleList] = React.useState(sortedScheduleConstraints);
  const [toAddNewRules, setToAddNewRules] = React.useState(false);
  const toggleToAddNewRules = () => {
    
    setToAddNewRules(true);
  };
  const onClickOfDelete = async (scheduleIndex,aschedule) => {
    let school = props.activeSchool;
    let index = school.schedule_constraints.findIndex((constraint) => (constraint['_id'] == aschedule['_id']))

    if (index != -1) {
      let removed = school.schedule_constraints.splice(index, 1)
      //await props.editSchoolInformation(props.userInformation._id, school._id, school);
      let result = await saveSchoolConcurrently(props.editSchoolInformation,
        props.userInformation._id,
        school._id,
        school,
        null);
      if (result.success) {
        let localIndex = scheduleList.findIndex((constraint) => (constraint['_id'] == aschedule['_id']))
        scheduleList.splice(localIndex, 1)
        setScheduleList(props.activeSchool.schedule_constraints)
      } else {
        school.schedule_constraints.splice(index, 0, ...removed);
      }

    }
  }
  const updateList = async () => {
    setScheduleList(props.activeSchool.schedule_constraints)
  }
  const editSchedule = async (schedule_constraints) => {
    let school = props.activeSchool;
    let index = school.schedule_constraints.findIndex((constraint) => (constraint['_id'] == schedule_constraints['_id']))
    if (index != -1) {
      school.schedule_constraints[index] = schedule_constraints
      //await props.editSchoolInformation(props.userInformation._id, school._id, school);

      // let result = await saveSchoolConcurrently(props.editSchoolInformation,
      //   props.userInformation._id,
      //   school._id,
      //   school,
      //   null);
      let result = await saveSchoolScheduleConstraintsConcurrently(props.updateSchoolScheduleConstraints,
        props.userInformation._id,
        school._id,
        school,
        index,
        null);
      if (result.success) {
        setScheduleList(props.activeSchool.schedule_constraints)
      }
    }
  }

  function filterList(event) {
    var filterBy = lodashUtil.split(event.target.value, ' ')
    var updatedList = props.activeSchool.schedule_constraints;
    updatedList = updatedList.filter(function (constraint) {
      let counter = 0;
      for (let i = 0; i < filterBy.length; i++) {
        if (constraint.name.toLowerCase().includes(filterBy[i].toLowerCase())) {
          counter++;
        }
      }
      if (counter == filterBy.length) {
        return true
      } else {
        return false
      }
    });
    const sortedScheduleConstraintsList = updatedList.sort((b, a) => new Date(a.modifiedDate).getTime() - new Date(b.modifiedDate).getTime())
    setScheduleList(sortedScheduleConstraintsList);
  }
  if (toAddNewRules) {
    return <Redirect to={{
      pathname: routes.addNewRules,
      state: {
        activeSchool: props.activeSchool,
        activeScheduleId: props.activeSchool.schedule_constraints[props.activeSchool.schedule_constraints.length - 1]['_id'],
        scheduleIndex: props.activeSchool.schedule_constraints.length - 1,
        stepperIndex: 0,
        disableEdit: false,
        overrideData: false
      }
    }} />
  } else {
    return (
      <div>
        {
          !props.updateSchoolinformationInProgress ?
            <MuiGrid container direction='row' style={{ paddingLeft: 20, width: '100%' }}>
              <MuiGrid item style={{ padding: "10px 0px", width: '100%' }} >

                <ScheduleTitleBarComponent {...props} filterList={filterList} updateList={updateList} toggleToAddNewRules={toggleToAddNewRules} />

              </MuiGrid>

              <MuiGrid item style={{ height: '60vh', overflowY: 'auto', width: '100%' ,paddingRight:10}} id='scrollStyleWithoutDisplay'>
                <ScheduleListComponent {...props} scheduleList={scheduleList} updateList={updateList} editSchedule={editSchedule} onClickOfDelete={onClickOfDelete} toggleToAddNewRules={toggleToAddNewRules} /></MuiGrid>
            </MuiGrid > :
            <MuiGrid container style={{ marginTop: '75px', width: '100%' }}

              justify='center' alignItems='center'
            >
              <img src={spinner} alt="none" style={theme.spinnerImgStyle} />

            </MuiGrid>
        }
      </div>
    )
  }
}


